var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import settings from '~/helpers/window-settings';
const subdomains = ['dev.', 'qa.', 'staging.'];
const subdomain = subdomains.find((sd) => { var _a; return (_a = settings().accountHref) === null || _a === void 0 ? void 0 : _a.includes(sd); }) || '';
const server = `https://${subdomain}salesforce.openstax.org`;
export function sfApiPost(objectType_1, data_1) {
    return __awaiter(this, arguments, void 0, function* (objectType, data, method = 'POST') {
        try {
            const options = {
                credentials: 'include',
                method,
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const raw = yield fetch(`${server}/api/v1/${objectType}`, options);
            if (!raw.ok) {
                const text = yield raw.json();
                console.warn('Failed with status', raw.status);
                console.warn(text.error);
            }
            return raw;
        }
        catch (err) {
            console.warn(`Fetch (${method}) ${objectType}: ${err}`);
            return null;
        }
    });
}
export default function sfApiFetch(objectType_1) {
    return __awaiter(this, arguments, void 0, function* (objectType, specifier = '') {
        try {
            const raw = yield fetch(`${server}/api/v1/${objectType}${specifier}`, {
                credentials: 'include',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Cache: 'no-0d4zFOeMPUmfxkCjHocCuoLa2SAGzBI8AREcH3eP3758F672DppA'
                }
            });
            const result = yield raw.json();
            return result;
        }
        catch (err) {
            console.warn(`Fetch ${objectType}: ${err}`);
            return null;
        }
    });
}
